import { TimeOffRequest, TimeOffRequestStatus } from '@/features/time-off/time-off.def.ts'
import dayjs, { Dayjs } from 'dayjs'

export const getConsumedBalance = (data: TimeOffRequest) => {
  return {
    totalConsumed: data.currentYearAmount + data.nextYearAmount,
    pendingDeduction: data.nextYearAmount,
  }
}

export const getTimeOffRequestDateDisplay = (data: TimeOffRequest, showPeriod: boolean = false) => {
  const format = 'D MMM YYYY'
  const start = dayjs(data.localStartTime)
  const startDateStr = start.format(format)
  const end = dayjs(data.localEndTime)
  const endDateStr = toInclusiveDateOnly(end, 'D MMM YYYY')
  const moreThanOneDay = startDateStr !== endDateStr
  if (moreThanOneDay && !showPeriod) {
    return `${startDateStr} - ${endDateStr}`
  }

  const startTimeStr = start.format('HH:mm')
  const endTimeStr = end.format('HH:mm')

  if (data.isHourlyRequest) {
    return `${startDateStr} (${startTimeStr} - ${endTimeStr})`
  }

  const endAtNoon = end.hour() === 12 && end.minute() === 0
  const startAtNoon = start.hour() === 12 && start.minute() === 0
  const isFullDay = !endAtNoon && !startAtNoon

  if (moreThanOneDay && showPeriod) {
    return `${startDateStr} ${startAtNoon ? '(afternoon) ' : ''}- ${endDateStr}${endAtNoon ? ' (morning)' : ''}`
  }


  return `${startDateStr} ${isFullDay ? '' : endAtNoon ? '(morning)' : '(afternoon)'}`
}

export const getTimeOffRequestTimeDisplay = (data: TimeOffRequest) => {
  const startTime = dayjs(data.localStartTime)
  const endTime = dayjs(data.localEndTime)
  const totalHours = endTime.diff(startTime, 'hour', true)
  return `${totalHours}h (${startTime.format('HH:mm')} - ${endTime.format('HH:mm')})`
}

export const getTimeOffRequestStatusColor = (data: TimeOffRequest) => {
  switch (data.status) {
    case TimeOffRequestStatus.Approved:
      return 'green'
    case TimeOffRequestStatus.Rejected:
      return 'red'
    case TimeOffRequestStatus.PendingManagerApproval:
      return 'orange'
    case TimeOffRequestStatus.PendingHcApproval:
      return 'blue'
    default:
      return 'default'
  }
}

export const toLocalDateTimeStr = (day?: Dayjs) => {
  return day ? day.format('YYYY-MM-DDTHH:mm:ss') : null
}

// should use this to transform date string from API response to inclusive end date for display
export const toInclusiveDateOnly = (date?: string | Dayjs, format = 'YYYY-MM-DD') => {
  if (!date) return undefined
  const obj = typeof date === 'string' ? dayjs(date) : date
  return obj.subtract(1, 'second').format(format)
}